import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getConversationsQueryKey } from "modules/conversations/lib/conversationsQuery"
import { CustomerResponseDataSchema, DataResponse, ToggleCustomerAISchema } from "schema"
import { z } from "zod"
import { customerLogsQuery } from "../lib/customerLogsQuery"
import { getCustomerQueryKey } from "../lib/customerQuery"
import { getCustomersQueryKey } from "../lib/customersQuery"

type Params = z.infer<typeof ToggleCustomerAISchema>
type Response = DataResponse<z.infer<typeof CustomerResponseDataSchema>>

export function useToggleCustomerAIMutation(customerId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await axios.patch<Response>(`/customers/${customerId}/toggle-ai`, params)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getCustomerQueryKey(customerId) })
      queryClient.invalidateQueries({ queryKey: customerLogsQuery(customerId).queryKey })
      queryClient.invalidateQueries({ queryKey: getCustomersQueryKey() })
      queryClient.invalidateQueries({ queryKey: getConversationsQueryKey() })
    },
  })
}
